import { Account } from '../../../types';
import { callExternalApi } from '../../callExternalApi';

export const getAccounts = async () => {
  return await callExternalApi<Account[]>({
    url: 'api/admin/accounts',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
